import React from 'react';
import { ShowIf } from 'components/utils';
import { connect } from 'react-redux';
import { Text, TextMessage } from 'components/tt-forms/common';
import { validatable } from 'components/utils';
import { ContainerFileDinhKem } from 'components/upload';
import {BlockGiaiQuyetDonInfo, BlockBanHanhQuyetDinhView} from 'modules/giai-quyet-don/subView';

class LanhDaoGiaoViecTheoDoiGiamSatView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      DataDetail: this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? this.props.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : [],
      DataGiaiQuyet: this.props.thongTinXuLyGiaiQuyet
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      DataGiaiQuyet: nextProps.thongTinXuLyGiaiQuyet,
      DataDetail: nextProps.thongTinXuLyGiaiQuyet && nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo ? nextProps.thongTinXuLyGiaiQuyet.thongTinGiaiQuyetDonInfo : []
    })
  }

  render() {
    let DataGiaiQuyet = this.props.thongTinXuLyGiaiQuyet;
    let DataDetail = this.state.DataDetail;

    return (
      <section className="wrap-block">
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.state.DataDetail}/>
        <div className="row pl15 pr15">

          <BlockBanHanhQuyetDinhView donInfo={this.props.donInfo} thongTinGQD={this.state.DataDetail} dataKetLuanNoiDungKhieuNai={this.props.dataKetLuanNoiDungKhieuNai}/>
          <div className="col-100 no-gutter mt5">
            <h2 className="title-14 mb15">Thông tin giải quyết</h2>
          </div>
          <div className="row pl10 pr10">
            <Text value={DataGiaiQuyet.nextStateInfo.tenVietTat} label="Giao xử lý:" className='col-25 mb10'/>

            <ShowIf condition={DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' || DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO'}>
              <Text value={DataGiaiQuyet.phongBanGiaiQuyetInfo ? DataGiaiQuyet.phongBanGiaiQuyetInfo.ten : ''} label="Phòng ban giải quyết:" className='col-25 mb10'/>
            </ShowIf>

            <ShowIf condition={ DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG'  && this.state.phongBanGiaiQuyet != ''}>
              <Text value={DataGiaiQuyet.canBoXuLyChiDinhInfo ? DataGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} label="Trưởng phòng:" className='col-25 mb10'/>
            </ShowIf>

            <ShowIf condition={ DataGiaiQuyet.nextStateInfo.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' && this.state.phongBanGiaiQuyet != ''}>
              <Text value={DataGiaiQuyet.canBoXuLyChiDinhInfo ? DataGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} label="Công chức:" className='col-25 mb10'/>
            </ShowIf>
          </div>
          <div className="row pl10 pr10">
            <TextMessage label="Ý kiến xử lý:" value={DataGiaiQuyet.yKienGiaiQuyet ? DataGiaiQuyet.yKienGiaiQuyet : ''}/>
          </div>

          <ShowIf condition={this.state.showFile}>
            <div className="col-100 pb5 no-gutter">
              <ContainerFileDinhKem name="GiaoCQDT" label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
            </div>
          </ShowIf>
          <ShowIf condition={!DataDetail.boSungThongTin && (DataDetail.noiDungBoSungHoSo != '' && DataDetail.noiDungBoSungHoSo != null)}>
            <div className="col-100 no-gutter">
              <div className="wrap-big-line pt5 pb15">
                <span className="big-border"></span>
              </div>
              <div className="col-100 no-gutter mt5">
                <h2 className="title-14 mb15">BỔ SUNG THÔNG TIN</h2>
                <div className="row pl10 pr10">
                  <div className="col-50 no-gutter">
                    <TextMessage className="col-50 mb0-18" label="Lý do bổ sung:" value={String(DataDetail.noiDungBoSungHoSo)}/>
                  </div>
                </div>
              </div>
              <div className="col-100 pb5 no-gutter">
                <ContainerFileDinhKem name="BoSungTT" label="Danh sách văn bản bổ sung" hideDescription={true} dataShow={DataDetail.listTaiLieuVanThuBoSungHoSo} disableAttachFile={true}/>
              </div>
            </div>
          </ShowIf>
        </div>
      </section>
    );
  }
}

LanhDaoGiaoViecTheoDoiGiamSatView.defaultProps = {
  listNextStates: [],
  dataKetLuanNoiDungKhieuNai: [],
  dataKetQuaThucHien: [],
  ketQuaGiaiQuyetDon: [],
  validators: {},
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  onSave: false
}

function bindStateToProps(state) {
  return {
    lanhDaoList: state.duLieuHeThong.lanhDaoList,
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    dataKetQuaThucHien: state.duLieuHeThong.ketQuaThucHien,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(validatable(LanhDaoGiaoViecTheoDoiGiamSatView));



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/lanh-dao/LanhDaoGiaoViecTheoDoiGiamSatView.jsx